import Header from '../../__Layout/Header';
import React , {useState} from "react";
import Loader from '../../utils/Loader';
import { useGetReviewEnrollmentQuery } from "../../Services/api";
import DeleteEnrollReview from "./DeleteEnrollReview";
import UpdateEnrollment from "./UpdateEnrollment";
import {pageUrl,pageSize} from "../../utils/constants/constants";
export default function EnrollReview() {
    const [page, setPage] = useState(0);
    const [search, setSearch] = useState("");
    const {
        data: getReviewEnrollment,
        isLoading: isGetLoading,
      } = useGetReviewEnrollmentQuery({ pageUrl, params:  {search,page,pageSize}  });
      
      const getPrevious= () => {
        setPage(page-1);
        setSearch("");
      }
      const getNext=()=>{
        setPage(page+1);
        setSearch("");
      }
      const findSearch=(e)=>{
        setPage(0);
        setSearch(e.target.value);
      }
      const [studentId,setStudentId] = useState("");
       const truncateText = (text, wordLimit) => {
        const words = text.split(' ');
        if (words.length <= wordLimit) {
          return text;
        }
        return words.slice(0, wordLimit).join(' ') + '...';
      };
      if(isGetLoading) return  <Loader></Loader>
    return (
        <div className="vehicleCategories">
            <Header />
            <main id="main" className="main">
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title"> Review Registered Student</h5>
                    <ul className="nav nav-tabs nav-tabs-bordered d-flex" id="borderedTabJustified" role="tablist">
                       <li className="nav-item flex-fill" role="presentation">
                        <button className="nav-link w-100 active" id="home-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-home" type="button" role="tab" aria-controls="home" aria-selected="true"> Review Registered Student</button>
                        </li>
                        
                    </ul>
                    <div className="tab-content pt-2" id="borderedTabJustifiedContent">
                        <div className="tab-pane fade show active" id="bordered-justified-home" role="tabpanel" aria-labelledby="home-tab"> 
                            <section className="section">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-body table-responsive">
                                                <h5 className="card-title"></h5>
                                                <div className='row'>
                                                    <div className='col-lg-8'></div>
                                                    <div className='col-lg-4'>
                                                        <div className="datatable-search pull-right">
                                                            <input className="datatable-input" placeholder="Search..." type="search" title="Search within table" onChange={findSearch}/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th>#</th>
                                                                <th className='text-capitalize'>name</th>
                                                                <th className='text-capitalize'>email</th>
                                                                <th className='text-capitalize'>course</th>
                                                                <th className='text-capitalize'>mobile no</th>
                                                                <th className='text-capitalize'>payment</th>
                                                                <th className='text-capitalize'>address</th>
                                                                <th className='text-capitalize'>job position</th>
                                                                <th className='text-capitalize'>nationality</th>
                                                                <th className='text-capitalize'>recheck</th>
                                                                <th className='text-capitalize'>action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            getReviewEnrollment?.data?.data_array?.map((item) => {
                                                            return (
                                                                <tr key={item.id}>
                                                                    <th scope="row">{item.id}</th>
                                                                    <td>{item.first_name}{item.last_name} </td>
                                                                    <td>{item.email}</td>
                                                                    <td>{item.course?.course_name}</td>
                                                                    <td>{item.mobile}</td>
                                                                    <td>{item.paymentamount}</td>
                                                                    <td>{truncateText(item?.address, 4)}</td>
                                                                    <td>{item.job_position}</td>
                                                                    <td>{item.nationality}</td>
                                                                    <td>{item.nationality}</td>
                                                                    <td>

                                                                        <div className="btn-group" role="group">
                                                                            <button id="btnGroupDrop1" type="button" className="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                            Action
                                                                            </button>
                                                                            <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                                                            <button className="dropdown-item"  data-bs-toggle="modal" onClick={()=>setStudentId(item.id)} data-id={item.id} data-bs-target="#fullscreenModal" >
                                                                                <div className="icon text-info">
                                                                                <i className="bi bi-pencil-square"></i>
                                                                                    Review
                                                                                </div>
                                                                            </button>
                                                                                 <DeleteEnrollReview id={item.id} />                                                                            
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    
                                                                </tr>                                            
                                                                )  
                                                            })  
                                                        } 
                                                        </tbody>
                                                </table>                        
                                                <nav aria-label="Page navigation example">
                                                    <ul className="pagination">
                                                    {getReviewEnrollment?.data?.currentPage !==0 ? <li className="page-item"><button type="button" className="page-link" onClick={getPrevious}>Previous</button></li> :''}
                                                    <li className="page-item"> {getReviewEnrollment?.data?.currentPage+1} </li>                                                  
                                                    <li className="page-item"> of {getReviewEnrollment?.data?.totalPages}</li>
                                                    {getReviewEnrollment?.data?.currentPage !==getReviewEnrollment?.data?.totalPages ? <li className="page-item"><button type="button" className="page-link" onClick={getNext}>Next</button></li>:''}
                                                    </ul>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>  
                        </div>
                        <UpdateEnrollment id={studentId}></UpdateEnrollment>

                       {/* <AddEnroll /> */}
                    </div>
                </div>
            </div>
            </main>
           
        </div>
    );
}
